<template>
  <div id="view">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <!-- <div class="tipTitle">鉴别价格</div>

      <div class="bannnerLi flex">
        <div class="title">价格：</div>
        <div style="width: 500px" class="flex">
          <el-input v-model="basicPrice" type="number" placeholder="请输入">
            <template slot="append">元/瓶</template>
          </el-input>
        </div>
      </div> -->

      <div class="tipTitle">快递费</div>

      <div class="setBox">
        <div class="setList" v-for="(item, index) in info">
          <div class="bannnerLi flex">
            <div class="title">{{ item.title }}：</div>
            <div style="width: 200px" class="flex">
              <el-input v-model="item.basic" type="number" placeholder="请填写">
              </el-input>
            </div>
            <span style="margin: 0px 6px">瓶以下</span>
            <div style="width: 200px" class="flex">
              <el-input v-model="item.basicMoney" type="number" placeholder="请填写">
              </el-input>
            </div>
            <span style="margin-left: 6px">元</span>
          </div>

          <div class="bannnerLi flex">
            <div class="title">每超过：</div>
            <div style="width: 200px" class="flex">
              <el-input v-model="item.exceed" type="number" placeholder="请填写">
              </el-input>
            </div>
            <span style="margin: 0px 6px">瓶，增加</span>
            <div style="width: 200px" class="flex">
              <el-input v-model="item.exceedMoney" type="number" placeholder="请填写">
              </el-input>
            </div>
            <span style="margin-left: 6px">元</span>
          </div>
        </div>
      </div>

      <div class="bannnerLi submitBox flex">
        <el-button type="success" :disabled="submitShow" @click="submitFn"
          >保存</el-button
        >
        <!-- <el-button type="info" size="small" @click="returnFn">返回</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { delTips, isJSON, throttle } from "@/util/utils";
import mapFm from "@/components/mapFm";
import elUpload from "@/components/elUpload";
import wangEditor from "@/components/wangEditor";
export default {
  props: {},
  components: {
    mapFm,
    elUpload,
    wangEditor,
  },
  data() {
    return {
      // 历史记录
      historyArr: ["鉴别价格"],

      currentPage: 1,
      pageSize: 10,
      pageShow: "add",

      //轮播列表
      submitShow: false,

      // 是否编辑
      isEdit: false,

      // 数据
      listObj: {
        jdf: "",
        kdf: "",
      },

      basicPrice: "",
      info: [],
      tempInfo: [
        {
          title: "江浙沪内",
          city: ["江苏", "浙江", "上海"],
          basic: "",
          basicMoney: "",
          exceed: "",
          exceedMoney: "",
        },
        {
          title: "安徽",
          city: ["安徽"],
          basic: "",
          basicMoney: "",
          exceed: "",
          exceedMoney: "",
        },
        {
          title: "其他省外",
          city: ["省外"],
          basic: "",
          basicMoney: "",
          exceed: "",
          exceedMoney: "",
        },
      ],
    };
  },

  created() {
    this.selList();
  },
  mounted() {},
  //监听数据
  computed: {},
  methods: {
    // 添加历史
    historyFn(title, str) {
      this.historyArr.push(title);
      this.pageShow = str;
    },

    // 图片上传前
    beforeUpload: function (res) {},

    //获取文本
    getArticleTxt: function (res) {
      this.$set(this.listObj, "depict", res);
    },

    // 图片上传
    getImgFn: function (path) {
      this.$set(this.listObj, "images", path);
    },
    // 图片上传
    getImgFn2: function (path) {
      this.$set(this.listObj, "jstp", path);
    },

    // 鉴别时效图片
    getIdentifyImgFn: function (path) {
      this.$set(this.listObj, "jbsxts", path);
    },

    // 获取富文本
    getTxt: function (res) {
      this.listObj.depict = res;
    },

    // 查询
    selList: function () {
      var urls = this.$api.api.selCharge;
      var data = {
        page: 1,
        size: 1,
      };
      this.$https(urls, data, "POST").then((res) => {
        if (res.data.code == 200) {
          let dataInfo = res.data.data;

          if (dataInfo && dataInfo.length) {
            let data = res.data.data[0];
            this.basicPrice = data.jdf || 0;
            let info = isJSON(data.kdf)
              ? JSON.parse(data.kdf)
              : JSON.parse(JSON.stringify(this.tempInfo));

            if (info) {
              this.info = info;
              this.listObj = data;
            } else {
              this.info = JSON.parse(JSON.stringify(this.tempInfo));
            }
          } else {
            this.info = JSON.parse(JSON.stringify(this.tempInfo));
          }
        }
      });
    },

    //提交数据
    submitFn: throttle(function (res) {
      let info = this.info;

      // if (!this.basicPrice) {
      //   this.$message.error("请输入下单价格");
      //   return;
      // }

      for (let i = 0; i < info.length; i++) {
        if (
          !info[i].basic ||
          !info[i].basicMoney ||
          !info[i].exceed ||
          !info[i].exceedMoney
        ) {
          this.$message.error("请填写完整信息");
          return;
        }
      }

      let obj = {
        jdf: this.basicPrice,
        kdf: JSON.stringify(info),
      };

      var urls = "";
      if (this.listObj.id) {
        urls = this.$api.api.upCharge;
        obj.id = this.listObj.id;
      } else {
        urls = this.$api.api.addCharge;
      }

      this.$https(urls, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
          this.selList();
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    closeFn: function () {
      this.excellenShow = 0;
      this.selList(this.currentPage);
    },
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;

  // 头部
  .topBox {
    width: 100%;
    margin-bottom: 10px;
    text-align: right;
  }

  .bannerTop {
    margin-bottom: 20px;
  }

  /* 头部起始位置 */
  .el-header {
    height: 50px !important;
    line-height: 50px;
    border-bottom: 2px solid #bebebe;
  }

  .banner {
    width: 100%;
    overflow: hidden;

    .el-icon-plus,
    img {
      width: 200px;
      height: 110px;
      border: 2px dashed #dedede;
      line-height: 120px;
      text-align: center;
      font-size: 28px;
      color: #999;
    }

    .Btn {
      background: red;
      margin-left: 15px;
    }
  }

  // 轮播图列表
  .bannerImg {
    width: 180px;
    height: 70px;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .bannerList {
    width: 100%;
  }

  // 新增图片
  .addBanner {
    width: 100%;
    padding: 5px 20px;
    box-sizing: border-box;
  }

  .tipTitle {
    font-size: 16px;
    line-height: 40px;
    font-weight: bold;
  }

  .setList {
    display: inline-block;
    border-bottom: 2px solid #eee;
    margin-left: 80px;
    padding: 0px 10px;
    box-sizing: border-box;
    margin-top: 20px;
  }

  .setList:last-child {
    border: 0;
  }

  .bannnerLi {
    width: 100%;
    margin-bottom: 25px;
    display: flex;

    .title {
      width: 90px;
      line-height: 40px;
      flex-shrink: 0;
    }
  }
}

.submitBox {
  padding-left: 80px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/RechargeAdmin/logisticsMoney.vue